import { BonusType, Bonus, eBonusType } from "./Bonus";
import { Pool } from "../../../Utils/Collections/Pool";
import { NodeList } from "../../../Utils/Collections/NodeList";
import { eGameAPI, eModelAsset, eSfxSprite, Game } from "../../../Game";
import { Node } from "../../../Utils/Collections/Node";
import { ViewCellMapRow } from "../View/ViewCellMapRow";
import { HUD } from "../HUD/HUD";
import { Player } from "../Player/Player";
import { Gameplay } from "../../Gameplay";
import { PwuManager } from "../../Powerups/PwuManager";
import { ePwuType } from "../../Powerups/PwuType";
import { eMisstionType } from "../../Gamee Missions/MissionType";
import { SoundManager } from "../../../Utils/SoundManager";



export class BonusManager {
    /**
     * (RO) Staticky pristup
     */
    static get instance(): BonusManager { return BonusManager._INSTANCE; }
    private static _INSTANCE: BonusManager;

    /**
     * Typy bonusu
     */
    private static _TYPES: BonusType[];

    /**
     * Pool s volnymi bonusy
     */
    private _freeBonuses: Pool<Bonus>;

    /**
     * Seznam aktivnich bonusu
     */
    private _actBonuses: NodeList<Bonus>;

    /**
     * Index skupiny posledne aktivovaneho bonusu
     */
    private _actGroupId: number;

    /**
     * Znacka skupiny posledne aktivovaneho bonusu
     */
    private _actGroupMark: number;

    /**
     * Cislo sekce herni mapy s aktualni skupinou bonusu
     */
    private _actGroupRowSecNum: number;

    /**
     * Index skupiny posledne sebraneho bonusu
     */
    private _pickedUpGroupId: number;

    /**
     * Pocet bonusu sebranych v aktualni skupine
     */
    private _pickedUpGroupSize: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        BonusManager._INSTANCE = this;

        // Typy bonusu
        BonusManager._TYPES = [
            // Zakladni
            new BonusType(eBonusType.point, 10, eModelAsset.bonus_0, 0.15, 0.4, 1, new pc.Vec3(90, 90, 0)),
            // Score multiplier
            new BonusType(eBonusType.scoreMultiplier, 0, eModelAsset.bonus_1, 0.2, 0.2, 1.5, new pc.Vec3(0, 90, 0))
        ];

        // Pool s volnymi bonusy
        this._freeBonuses = new Pool<Bonus>(Bonus, 5, true);

        // Seznam aktivnich bonusu
        this._actBonuses = new NodeList<Bonus>();

        // Zachytavat udalost sebrani bonusu
        Gameplay.instance.events.on(Bonus.EVENT_PICKED_UP, this.handleBonusPickup, this);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        // Uvolnit aktivni bonusy
        this._actBonuses.forEach((bns: Bonus) => {
            this._freeBonuses.returnItem(bns);
            bns.release();
        });
        this._actBonuses.clear();

        // Skupina
        this._actGroupId = -1;
        this._actGroupMark = -1;
        this._actGroupRowSecNum = -1;
        this._pickedUpGroupId = -1;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        // Volat update() pro aktivni bonusy
        this._actBonuses.forEach((bns: Bonus, node: Node<Bonus>) => {
            if (!bns.update()) {
                this._freeBonuses.returnItem(this._actBonuses.removeByNode(node));
            }
        }, this);
    }

    //-------------------------------------------------------------------------
    /**
     * Aktivace bonusu
     * @param type Typ bonusu
     * @param groupMark Znacka skupiny bonusu (0 nebo 1)
     * @param cellId Index bunky v ramci radky
     * @param row Radka
     * @param rowSecNum Cislo sekce, do ktere radka patri
     */
    //-------------------------------------------------------------------------
    initBonus(type: eBonusType, groupMark: number, cellId: number, row: ViewCellMapRow, rowSecNum: number): void {
        let bns = this._freeBonuses.getItem();

        if (groupMark != this._actGroupMark || this._actGroupRowSecNum != rowSecNum) {
            this._actGroupMark = groupMark;
            this._actGroupRowSecNum = rowSecNum;
            this._actGroupId++;
        }

        bns.init(BonusManager._TYPES[type], this._actGroupId, cellId, row);
        this._actBonuses.add(bns);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleBonusPickup(bonus: Bonus, pos: pc.Vec3): void {
        let pl = Player.instance;

        switch (bonus.type.type) {
            case eBonusType.point: {
                let score = bonus.type.score;

                // Navysit skore            
                if (bonus.groupId == this._pickedUpGroupId) {
                    score *= ++this._pickedUpGroupSize;
                }
                else {
                    this._pickedUpGroupId = bonus.groupId;
                    this._pickedUpGroupSize = 1;
                }

                score = pl.score.incScore(score);

                // Zobrazit popup
                HUD.instance.showScorePopup(pos.x, pos.y + 0.5, pos.z, "+" + score.toString());

                // Sfx
                SoundManager.playSound(pl.entity, eSfxSprite.bonusCollect);

                // Mise
                if (Game.API == eGameAPI.GAMEE)
                    Game.missions.incMissionProgress(eMisstionType.collectRings);

                break;
            }
            case eBonusType.scoreMultiplier: {
                // Aktivovat powerup
                PwuManager.INSTANCE.activatePwu(ePwuType.scoreMultiplier);

                // Zobrazit popup
                HUD.instance.showScorePopup(pos.x, pos.y + 0.5, pos.z, "SCORE " + pl.score.multiplier + "X");

                break;
            }
        }

    }
}